/**
 * Marks given label as required by adding a space and an asterisk to the end of its right-trimmed text.
 * @param label The label text.
 */
export function asRequired(label: string): string {
    return label.trimEnd() + ' *';
}
